import { Component } from '@angular/core';
import { LoginType } from '../../classes/static/enums';
import { LoginService } from '../../services/login.service';

@Component({
	selector: 'user-type-selection-form',
	template: require('./user-type-selection-form.component.html'),
})
export class UserTypeSelectionFormComponent {
	retailSelected() {
		LoginService.setType(LoginType.Retail);
	}

	corporateSelected() {
		LoginService.setType(LoginType.Corporate);
	}
}
